import {
    Box, Card, CardActionArea, CardContent, CardMedia,
    Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
    tableCellClasses
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useEffect, useMemo, useState } from "react";
import { FerramentasDaListagem } from "../../shered/components";
import { LayoutBaseDePagina } from "../../shered/layouts/LayoutBaseDePagina";
import { IDadosEstatisticas, IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { FranquiaService } from "../../shered/services/api/franquia/FranquiaService";
import { IDadosLigaCard, LigaService } from "../../shered/services/api/liga/LigaService";
import { Enviroment } from "../../shered/enviroments";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../shered/contexts";
import { styled } from '@mui/material/styles';
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
//import Iframe from "../../shered/components/video/Iframe";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Carousel } from "../../shered/components/carousel/carousel";

export const Dashboard = () => {
    const { isAuthenticated, logout } = useAuthContext();
    const navigate = useNavigate();
    const user = CookieService.get("access_user");
    const dado = UtilidadeService.crypt(user.codUsuario.toString());
    const dadosIncompletos = CookieService.get("dados_Incompletos");

    const [isLoadingJogador, setIsLoadigJogador] = useState(true);
    const [totalCountJogadores, setTotalCountJogadores] = useState(0);
    const [isLoadingFranquias, setIsLoadingFranquia] = useState(true);
    const [totalCountFranquias, setTotalCountFranquias] = useState(0);
    const [isLoadingLiga, setIsLoadingLiga] = useState(true);
    const [totalCountLigas, setTotalCountLigas] = useState(0);
    const [rows, setRows] = useState<IListagemJogador[]>([]);
    const [estatisticasRows, setEstatisticasRows] = useState<IDadosEstatisticas[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [lstDadosLigaCard, setLstDadosLigaCard] = useState<IDadosLigaCard[]>([]);
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    useEffect(() => {
        localStorage.setItem("paginaVoltar", "");
        if (!isAuthenticated) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Sessão expirada!",
                display: "none",
                titulo: "Atenção"
            });
            logout();
            setRedirecionar("0");
            return;
        }

        if (dadosIncompletos === "true") {
            setShowModalMensagem(true);
             setRedirecionar("");
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Cadastro com dados imcompletos! Favor realizar a atualização.",
                display: "none",
                titulo: "Atenção"
            });

            setTimeout(() => {
                navigate(`/usuario/usuarios/detalhe/${dado}`);
            }, 3000);

            return;
        }

        let codLocal = localStorage.getItem("@codigoLiga");
        let codigoLiga = codLocal !== null ? UtilidadeService.decrypt(codLocal) : null;
        if (codigoLiga !== "" && codigoLiga !== undefined && codigoLiga !== null) {
            navigate(`/usuario/liga/${codLocal}`);
            return;
        }

        setIsLoadingFranquia(true);
        setIsLoadingLiga(true)

        LigaService.getAllLigasDashboard(1, busca)
            .then((result) => {
                setIsLoading(false);
                setIsLoadingLiga(false);

                const lst = result.data.dado;
                //console.log(lst);
                setLstDadosLigaCard(lst);
                setTotalCountLigas(result.data.dado.length)
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoadingLiga(false);
            });


        JogadorService.getAll(1, busca)
            .then((result) => {
                setIsLoadigJogador(false);
                setIsLoading(false);

                const lst = result.data.dado;
                setRows(lst);
                setTotalCountJogadores(result.data.totalRegistros);

            }).catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                return;
            });

        JogadorService.getEstatisticasJogador(0)
            .then((result) => {
                setIsLoadigJogador(false);
                setIsLoading(false);
                const lst = result.dado;
                setEstatisticasRows(lst);

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

        FranquiaService.getAll(1)
            .then((result) => {
                setIsLoadingFranquia(false);
                setIsLoading(false);

                const lst = result.data.dado;
                setTotalCountFranquias(result.data.totalRegistros);
                setIsLoadingFranquia(false);

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }, [localStorage.getItem("@codigoLiga")]);


    //#region Configuração tabela

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: "5px"
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const handleVerificarValoresTabela = (valor: any) => {
        if (valor !== undefined && valor !== null) {
            return valor.toFixed(2).replace(".", ",");
        }
        return 0;
    }

    //#endregion

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    };

    return (
        <LayoutBaseDePagina
            titulo="Página Inicial"
            barraDeFerramentas={<FerramentasDaListagem
                mostrarBotaoNovo={true}
                textoBotaoNovo="NOVA LIGA"
                textoDaBusca={busca}
                aoClicarBotaoNovo={() => navigate('/usuario/liga/detalhe/nova')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                <Grid container direction="column" padding={2} spacing={3}>
                    <Grid container size={{ xs: 12 }} spacing={2}>
                        {!isLoadingLiga && lstDadosLigaCard.length > 0 ? (lstDadosLigaCard.slice(0, 8).map(liga => (
                            <Grid key={liga.codigo} size={{ xs: 12, sm: 6, md: 3 }}   >
                                <Card key={liga.codigo}
                                //onClick={() => { localStorage.setItem("paginaVoltar", "d"); navigate(`/liga/${liga.codigo}`); localStorage.setItem("@codigoLiga", liga.codigo.toString()); }}
                                >
                                    <CardActionArea>
                                        <CardMedia
                                            component="img"
                                            alt="green iguana"
                                            height="140"
                                            image={liga.caminho_Logo}
                                            key={liga.codigo}
                                        />
                                        <CardContent sx={{ padding: 1, paddingBottom: 1 }} >
                                            <Grid  >
                                                <Box width="100%" display="flex" flexDirection="column">
                                                    <Typography variant="h6" >
                                                        {liga.nome}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {liga.nomeFranquia}
                                                    </Typography>
                                                    <Typography variant="body2" >
                                                        {liga.classificacao}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        {liga.conferencia}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        )))
                            : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                <Typography variant="h6">Nenhuma liga cadastrada</Typography>
                                <hr />
                            </Grid>
                        }

                    </Grid>
                    <Grid container size={{ xs: 12, sm: 12 }}>
                        <Carousel />
                    </Grid>
                    {/* <Grid  size={{xs:12, sm:12}} height="500px" display="flex" justifyContent="center">
                        <Iframe />
                    </Grid> */}

                    {/* <Grid container spacing={2}>
                        <Grid size={{xs:12, sm:6, md:3}} lg={3} xl={3}  >
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" align="center">
                                        Jogadores
                                    </Typography>
                                    <Box padding={3} display="flex" justifyContent='center' alignItems='center'>
                                        {!isLoadingJogador && (
                                            <Typography variant="h6">
                                                {totalCountJogadores}
                                            </Typography>
                                        )}
                                        {isLoadingJogador && (
                                            <Typography variant="h6">
                                                Carregando...
                                            </Typography>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid size={{xs:12, sm:6, md:3}} lg={3} xl={3}  >
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" align="center">
                                        Ligas
                                    </Typography>
                                    <Box padding={3} display="flex" justifyContent='center' alignItems='center'>
                                        {!isLoadingLiga && (
                                            <Typography variant="h6">
                                                {totalCountLigas}
                                            </Typography>
                                        )}
                                        {isLoadingLiga && (
                                            <Typography variant="h6">
                                                Carregando...
                                            </Typography>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid size={{xs:12, sm:6, md:3}} lg={3} xl={3} >
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" align="center">
                                        Franquias das Ligas
                                    </Typography>
                                    <Box padding={3} display="flex" justifyContent='center' alignItems='center'>
                                        {!isLoadingFranquias && (
                                            <Typography variant="h6">
                                                {totalCountFranquias}
                                            </Typography>
                                        )}
                                        {isLoadingFranquias && (
                                            <Typography variant="h6">
                                                Carregando...
                                            </Typography>
                                        )}
                                    </Box>

                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid> */}
                </Grid>
                <Grid container direction="column" padding={2} spacing={3}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} >
                            <Typography variant="h6"> ESTATÍSTICAS DOS JOGADORES NBA</Typography>
                            <hr />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}   >
                            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "330", height: "600" }}>
                                <Table>
                                    <TableHead sx={{ padding: "10px" }}>
                                        <TableRow>
                                            <StyledTableCell>Foto</StyledTableCell>
                                            <StyledTableCell>Nome</StyledTableCell>
                                            {estatisticasRows.find(f => f.quantidade_Jogos !== null) && <StyledTableCell align="center">Jogos</StyledTableCell>}
                                            {estatisticasRows.find(f => f.minutos !== null) && <StyledTableCell align="center">Minutos</StyledTableCell>}
                                            {estatisticasRows.find(f => f.arremessos !== null) && <StyledTableCell align="center">FGM</StyledTableCell>}
                                            {estatisticasRows.find(f => f.lance_Livre !== null) && <StyledTableCell align="center">FTM</StyledTableCell>}
                                            {estatisticasRows.find(f => f.tres_Pontos !== null) && <StyledTableCell align="center">3PM</StyledTableCell>}
                                            {estatisticasRows.find(f => f.pontos !== null) && <StyledTableCell align="center">PTS</StyledTableCell>}
                                            {estatisticasRows.find(f => f.rebotes !== null) && <StyledTableCell align="center">REB</StyledTableCell>}
                                            {estatisticasRows.find(f => f.rebotes_Ofensivos !== null) && <StyledTableCell align="center">OREB</StyledTableCell>}
                                            {estatisticasRows.find(f => f.rebotes_Defensivos !== null) && <StyledTableCell align="center">DREB</StyledTableCell>}
                                            {estatisticasRows.find(f => f.assistencias !== null) && <StyledTableCell align="center">AST</StyledTableCell>}
                                            {estatisticasRows.find(f => f.steal !== null) && <StyledTableCell align="center">STL</StyledTableCell>}
                                            {estatisticasRows.find(f => f.bloqueios !== null) && <StyledTableCell align="center">BLK</StyledTableCell>}
                                            {estatisticasRows.find(f => f.turnovers !== null) && <StyledTableCell align="center">TO</StyledTableCell>}
                                            {estatisticasRows.find(f => f.faltas !== null) && <StyledTableCell align="center">PF</StyledTableCell>}
                                            {estatisticasRows.find(f => f.min_Plus !== null) && <StyledTableCell align="center">MPLU</StyledTableCell>}
                                            {estatisticasRows.find(f => f.porcentagem_Arremessos !== null) && <StyledTableCell align="center">FG%</StyledTableCell>}
                                            {estatisticasRows.find(f => f.porcentagem_Lance_Livre !== null) && <StyledTableCell align="center">FT%</StyledTableCell>}
                                            {estatisticasRows.find(f => f.porcentagem_Tres_Pontos !== null) && <StyledTableCell align="center">3P%</StyledTableCell>}

                                            {estatisticasRows.find(f => f.arremessos_Errados !== null) && <StyledTableCell align="center">FGE</StyledTableCell>}
                                            {estatisticasRows.find(f => f.lance_Livre_Errados !== null) && <StyledTableCell align="center">FTE</StyledTableCell>}
                                            {estatisticasRows.find(f => f.tres_Pontos_Errados !== null) && <StyledTableCell align="center">threepe</StyledTableCell>}
                                            {estatisticasRows.find(f => f.stocks !== null) && <StyledTableCell align="center">STOCKS</StyledTableCell>}


                                            <StyledTableCell>Total</StyledTableCell>


                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {estatisticasRows.slice(0, 20).map(row => (
                                            <StyledTableRow key={row.codigo} >
                                                <StyledTableCell><img src={row.foto} alt={row.nome} width={50} height={50} /></StyledTableCell>
                                                <StyledTableCell>{row.nome}</StyledTableCell>
                                                {row.quantidade_Jogos !== undefined && row.quantidade_Jogos !== null && <StyledTableCell align="center">{row.quantidade_Jogos}</StyledTableCell>}
                                                {row.minutos !== null && <StyledTableCell align="center">{row.minutos.toFixed(0)}</StyledTableCell>}
                                                {row.arremessos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.arremessos)}</StyledTableCell>}
                                                {row.lance_Livre !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.lance_Livre)}</StyledTableCell>}
                                                {row.tres_Pontos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.tres_Pontos)}</StyledTableCell>}
                                                {row.pontos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.pontos)}</StyledTableCell>}
                                                {row.rebotes !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.rebotes)}</StyledTableCell>}
                                                {row.rebotes_Ofensivos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.rebotes_Ofensivos)}</StyledTableCell>}
                                                {row.rebotes_Defensivos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.rebotes_Defensivos)}</StyledTableCell>}
                                                {row.assistencias !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.assistencias)}</StyledTableCell>}
                                                {row.steal !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.steal)}</StyledTableCell>}
                                                {row.bloqueios !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.bloqueios)}</StyledTableCell>}
                                                {row.turnovers !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.turnovers)}</StyledTableCell>}
                                                {row.faltas !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.faltas)}</StyledTableCell>}
                                                {row.min_Plus !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.min_Plus)}</StyledTableCell>}
                                                {row.porcentagem_Arremessos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Arremessos)}</StyledTableCell>}
                                                {row.porcentagem_Lance_Livre !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Lance_Livre)}</StyledTableCell>}
                                                {row.porcentagem_Tres_Pontos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Tres_Pontos)}</StyledTableCell>}
                                                {row.peso_Total_Jogador !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.peso_Total_Jogador)}</StyledTableCell>}
                                            </StyledTableRow >
                                        ))
                                        }
                                    </TableBody>
                                    {totalCountJogadores === 0 && !isLoading && (
                                        <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                    )}
                                    {/* <TableFooter>
                                        {isLoading && (
                                            <TableRow>
                                                <TableCell colSpan={7}>
                                                    <LinearProgress variant="indeterminate" />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {(totalCountJogadores > 0 && totalCountJogadores > 30) && (
                                            <TableRow>
                                                <TableCell colSpan={7}>
                                                    <Pagination
                                                        page={1}
                                                        count={Math.ceil(totalCountJogadores / 30)}
                                                        onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableFooter> */}
                                </Table>
                            </TableContainer>
                        </Grid>
                        {/* <Grid  size={{xs:12, sm:12}} >
                            <Typography variant="h6"> Ligas</Typography>
                        </Grid>
                        <Grid size={{xs:12, sm:6}}   >
                            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "350" }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width={50}>Código</TableCell>
                                            <TableCell>Foto</TableCell>
                                            <TableCell>Nome</TableCell>
                                            <TableCell>ID NBA</TableCell>
                                            <TableCell>Franquia</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map(row => (
                                            <TableRow key={row.codigo}>
                                                <TableCell>{row.codigo}</TableCell>
                                                <TableCell><img src={row.foto} alt={row.nome} width={40} height={40} /></TableCell>
                                                <TableCell>{row.nome}</TableCell>
                                                <TableCell>
                                                    {row.codigo_NBA}
                                                </TableCell>
                                                <TableCell>
                                                    {row.franquia_Atual}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        }
                                    </TableBody>
                                    {totalCountJogadores === 0 && !isLoading && (
                                        <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                    )}
                                    <TableFooter>
                                        {isLoading && (
                                            <TableRow>
                                                <TableCell colSpan={7}>
                                                    <LinearProgress variant="indeterminate" />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {(totalCountJogadores > 0 && totalCountJogadores > 30) && (
                                            <TableRow>
                                                <TableCell colSpan={7}>
                                                    <Pagination
                                                        page={1}
                                                        count={Math.ceil(totalCountJogadores / 30)}
                                                        onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    );
}